module.exports = {
    host: "https://bksaid.vastok.uz",
    // host: "http://localhost:8000",
    // host: "https://backend.gold-uz.uz",
};
